<template>
  <div class="aside">
    <el-menu 
      mode="vertical" 
      text-color="black" 
      :default-active="activeIndex" 
      :background-color="themeColor2" 
      :active-text-color="themeColor3" 
      @select="handleSelect"
    >
      <!-- <span v-for="(item, key) in asideMenus" :key="key"> -->
      <span v-for="(item, key) in filteredMenus" :key="key">
        <router-link :to="item.path">
          <el-menu-item :index="`${key}`" :route="activeMenu">
            <!-- <el-image style="width:25px; height:25px" fit="fill" :src="url(item.icon)" /> -->
            <svg-icon style="width:25px; height:25px;" :icon-name="item.icon" />
            <span class="aside-text">&nbsp;{{ item.title }}</span>
          </el-menu-item>
        </router-link>
      </span>
    </el-menu>
  </div>
</template>


<script>
// import { themeColor, themeColor2 } from '@/assets/variables.scss'
import variables from '@/assets/variables.module.scss'
import SvgIcon from '@/components/SvgIcon.vue'
import { consts } from '@/utils/consts'

export default {
  name: "Aside",
  components: { SvgIcon },
  data() {
    return {
      themeColor2: variables.themeColor2,
      themeColor3: variables.themeColor3,
      asideMenus: consts.AsideMenus,
      activeIndex: "0",
      roles: this.$store.getters.roles,
    }
  },
  computed: {
    activeMenu() {
      const route = this.$route;
      const { meta, path } = route;
      // if set path, the aside will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    },
    filteredMenus() {
      // 如果没有权限限制，直接返回所有菜单
      if (!this.roles || this.roles.length === 0) {
        return this.asideMenus;
      }
      // 过滤菜单，只显示有权限的
      return this.asideMenus.filter(item => {
        // 如果菜单没有设置 roles，默认所有用户可见
        if (!item.roles || item.roles.length === 0) {
          return true;
        }
        // 检查当前用户角色是否在菜单允许的角色中
        return item.roles.some(role => this.roles.includes(role));
      }).map(item => {
        // 为每个菜单项解析正确的路径
        const resolvedPath = this.resolveMenuPath(item);
        return {
          ...item,
          resolvedPath // 添加解析后的路径
        };
      });
    },    
  },
  methods: {
    // 解析菜单路径的方法
    resolveMenuPath(item) {
      // 如果没有roles或只有一个角色，返回数组的第一个路径
      if (!item.path || !Array.isArray(item.path)) {
        return '#';
      }
      
      const userRole = this.roles[0]; // 取第一个角色
      
      // 映射角色到数组索引
      const roleIndexMap = {
        'admin': 0,
        'agent': 1,
        'customer': 2,
      };
      
      // 获取对应的索引
      const index = roleIndexMap[userRole];
      
      // 如果索引有效且在数组范围内，返回对应的路径
      if (index !== undefined && index < item.path.length) {
        return item.path[index];
      }
      
      // 否则返回第一个路径作为默认
      return item.path[0];
    },    
    handleSelect(index) {
      this.activeIndex = String(index);
      // const { path } = this.asideMenus[index];
      // this.$router.push(path);
      const filteredItem = this.filteredMenus[index];
      if (filteredItem && filteredItem.resolvedPath) {
        this.$router.push(filteredItem.resolvedPath);
      }
    },    
    url(filename) {
      return `@/assets/icons/img/${filename}.png`;
    }
  }
};
</script>


<style lang="scss" scoped>
@import "@/assets/variables.scss";

a {
  text-decoration: none !important; /* Remove underline */
}
.aside {
  position: absolute;
  top: $header-height+2;
  left: 0;
  width: $aside-width;
  height: 100%;
  z-index: 1;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 20px 0;
  background-color: $theme-color2;
  // border-right: 1px solid $theme-color;
  text-align: left;
}
.aside {
  .el-menu {
    width: $aside-width;
  }
  .el-menu-item.is-active {
    background-color: $theme-color !important;
  }
}
.aside-text {
  font-size: 1.2em;
}
</style>